<template>
    <div class="sale-detail container">
      <layout>
          <template #content>
              <content-container>
                  <div class="sale-detail__item">
                      <span class="sale-detail__item-name">{{ textLocales.type }}</span>
                      <span v-if="data.item.type" class="sale-detail__item-value" v-html="data.item.type"/>
                      <span v-else class="sale-detail__item-value">—</span>
                  </div>
                  <div class="sale-detail__item">
                      <span class="sale-detail__item-name">{{ textLocales.subType }}</span>
                      <span v-if="data.item.subType" class="sale-detail__item-value" v-html="data.item.subType"/>
                      <span v-else class="sale-detail__item-value">—</span>
                  </div>
                  <div class="sale-detail__item">
                      <span class="sale-detail__item-name">{{ textLocales.techProps }}</span>
                      <span v-if="data.item.techProps" class="sale-detail__item-value" v-html="data.item.techProps"/>
                      <span v-else class="sale-detail__item-value">—</span>
                  </div>
                  <div class="sale-detail__item">
                      <span class="sale-detail__item-name">{{ textLocales.brand }}</span>
                      <span v-if="data.item.brand" class="sale-detail__item-value" v-html="data.item.brand"/>
                      <span v-else class="sale-detail__item-value">—</span>
                  </div>
                  <div class="sale-detail__item">
                      <span class="sale-detail__item-name">{{ textLocales.gost }}</span>
                      <span v-if="data.item.gost" class="sale-detail__item-value" v-html="data.item.gost"/>
                      <span v-else class="sale-detail__item-value">—</span>
                  </div>
                  <div class="sale-detail__item">
                      <span class="sale-detail__item-name">{{ textLocales.code }}</span>
                      <span v-if="data.item.code" class="sale-detail__item-value" v-html="data.item.code"/>
                      <span v-else class="sale-detail__item-value">—</span>
                  </div>
                  <div class="sale-detail__item">
                      <span class="sale-detail__item-name">{{ textLocales.amount }}</span>
                      <span v-if="data.item.amount" class="sale-detail__item-value" v-html="data.item.amount"/>
                      <span v-else class="sale-detail__item-value">—</span>
                  </div>
                  <div class="sale-detail__item">
                      <span class="sale-detail__item-name">{{ textLocales.amountName }}</span>
                      <span v-if="data.item.amountName" class="sale-detail__item-value" v-html="data.item.amountName"/>
                      <span v-else class="sale-detail__item-value">—</span>
                  </div>
                  <div class="sale-detail__item">
                      <span class="sale-detail__item-name">{{ textLocales.price }}</span>
                      <span v-if="data.item.price" class="sale-detail__item-value u-bold" v-html="formattedNumber(data.item.price)"/>
                      <span v-else class="sale-detail__item-value">—</span>
                  </div>
                  <div class="sale-detail__item">
                      <span class="sale-detail__item-name">{{ textLocales.roks }}</span>
                      <span v-if="data.item.roks" class="sale-detail__item-value" v-html="data.item.roks"/>
                      <span v-else class="sale-detail__item-value">—</span>
                  </div>
                  <div class="sale-detail__content" v-html="data.item.comments" />
                  <template v-if="data.item.files.length">
                      <z-caption
                          tag="h3"
                          size="3xl"
                          weight="600"
                          class="sale-detail__title"
                      >
                          {{ textLocales.title }}
                      </z-caption>
                      <z-filelist size="m">
                          <z-filelist-item
                              v-for="(item, index) in data.item.files"
                              :key="index"
                              :name="item.name"
                              :href="item.link"
                              :icon-name="`file/${item.type}`"
                              :file-size="item.size"
                          />
                      </z-filelist>
                  </template>
              </content-container>
          </template>
      </layout>
    </div>
</template>

<script>
import { localize } from '@/utils/i18n'
import { mapActions } from 'vuex'

export default {
    name: 'sale-page-detail',
    data () {
        return {
            data: this.$root.app.components['illiquid-detail'],
            textLocales: {
                type: localize({
                    en: '',
                    ru: 'Наименование группы материалов'
                }),
                subType: localize({
                    en: '',
                    ru: 'Наименование подгруппы материалов'
                }),
                techProps: localize({
                    en: '',
                    ru: 'Технические характеристики'
                }),
                brand: localize({
                    en: '',
                    ru: 'Марка'
                }),
                gost: localize({
                    en: '',
                    ru: 'ГОСТ'
                }),
                code: localize({
                    en: '',
                    ru: 'Код ЕНС'
                }),
                amount: localize({
                    en: '',
                    ru: 'Количество к реализации'
                }),
                amountName: localize({
                    en: '',
                    ru: 'ЕИ кол.'
                }),
                price: localize({
                    en: '',
                    ru: 'Цена за единицу'
                }),
                roks: localize({
                    en: '',
                    ru: 'Данные о собственнике / балансодержателе'
                }),
                title: localize({
                    en: '',
                    ru: 'Прикреплённые файлы'
                })
            }
        }
    },
    created () {
        this.SetHeroTitle(this.data.item.name)
    },
    computed: {
        pageNav () {
            if (!(this.data.nav && (this.data.nav.next || this.data.nav.prev))) return
            let nav = Object.assign({}, this.data.nav)
            if (nav.next) nav.next.name = ''
            if (nav.prev) nav.prev.name = ''
            return nav
        }
    },
    methods: {
        ...mapActions([
            'SetHeroTitle',
        ]),
        formattedNumber (value) {
            const formattedValue = this.$options.filters.numberFilter(value)
            const normalizedValue = formattedValue.replace(',', '.').replace(/\s+/g, '')
            const numberValue = parseFloat(normalizedValue)
            if (!isNaN(numberValue)) {
                return numberValue.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            }
            return formattedValue
        }
    }
}
</script>

<style lang="scss">
.sale-detail {
    &__item {
        padding-bottom: $token-spacers-xs;
        display: flex;
        align-items: center;
        border-bottom: 1px solid $token-colors-gray-20;

        &:not(:last-of-type) {
            margin-bottom: $token-spacers-xs;
        }

        @include breakpoint(v-tablet) {
            flex-direction: column;
            align-items: start;
            gap: $token-spacers-2-xs;
        }

        &-name {
            padding-right: $token-spacers-xs;
            min-width: 320px;
            max-width: 320px;
            font-size: $token-typo-m-desktop-size;
            font-weight: 600;
            line-height: 1.5;
            color: $token-colors-gray-60;

            @include breakpoint(v-tablet) {
                padding: 0;
                min-width: auto;
                max-width: 100%;
            }
        }
        &-value {
            font-size: $token-typo-m-desktop-size;
            font-weight: 400;
            line-height: 1.5;
            color: $token-colors-gray-60;
        }
    }

    &__content {
        margin: $token-spacers-xl 0;
        font-size: $token-typo-m-desktop-size;
        font-weight: 400;
        line-height: 1.5;
    }
}
</style>
